import { Card } from "@mui/material";
import BudgetControlGraphFilter from "./BudgetControlGraphFilter";
import BudgetControlGraphItem from "./BudgetControlGraphItem";
import BudgetControlGraphView from "./BudgetControlGraphView";
import {
  colors,
  spacing,
} from "../../../../../../../../../assets/styles/tokens";
import { Box } from "@mui/system";
import BudgetControlGraphPagination from "./BudgetControlGraphPagination";

const BudgetControlGraph = () => {
  return (
    <>
      <BudgetControlGraphFilter />
      <Box sx={{ mt: "-" + spacing.Spacing.md.$value }}>
        <Card
          sx={{
            p: 1,
            borderRadius: spacing.Radius.lg.$value,
            boxShadow: "0px 1px 2px #0A0D120F , 0px 1px 3px #0A0D121A",
            border: "1px solid" + colors.GrayLightMode[200].$value,
            mb: spacing.Spacing.none.$value,
            mt: spacing.Spacing.xl.$value + "!important",
          }}
        >
          <BudgetControlGraphView />
          <BudgetControlGraphItem />
        </Card>
      </Box>
       <BudgetControlGraphPagination/>
    </>
  );
};

export default BudgetControlGraph;
